import React from 'react';
import styled from 'styled-components';
import { ReactComponent as HAALogo } from '../../assets/images/Logo/HardAssetsAllianceLogo.svg';
import GSLogo from '../../assets/images/Logo/GoldSilver_Logo.png';
import { ReactComponent as ContosoLogo } from '../../assets/images/Logo/ContosoLogo.svg';
import LPMLogo from '../../assets/images/Logo/LegacyPreciousMetalsLogo.png';
import config from '../../config';

const LogoStyles = styled.div`
  > img {
    height: 1.75rem;
    object-fit: contain;
  }
  > svg {
    height: 1.75rem;
    object-fit: contain;
    color: #ffffff;
  }
`;

const LogoLPMStyles = styled.div`
  > img {
    height: 2.75rem;
    object-fit: contain;
  }
`;

const Logo = () => {
  const { brokerTheme } = config;

  if (brokerTheme === 'HardAssetsAlliance') {
    return (
      <LogoStyles>
        <HAALogo />
      </LogoStyles>
    );
  }

  if (brokerTheme === 'GoldSilver') {
    return (
      <LogoStyles>
        <img src={GSLogo} alt="Broker Logo" />
      </LogoStyles>
    );
  }

  if (brokerTheme === 'LegacyPM') {
    return (
      <LogoLPMStyles>
        <img src={LPMLogo} alt="Broker Logo" />
      </LogoLPMStyles>
    );
  }

  if (brokerTheme === 'Contoso') {
    return (
      <LogoStyles>
        <ContosoLogo />
      </LogoStyles>
    );
  }

  return null;
};

Logo.propTypes = {};

export default Logo;
